<template>
  <Section :content="secureSharing" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionSecureSharing',
  components: {
    Section,
  },
  data() {
    return {
      secureSharing: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Secure Data Sharing',
        paragraphs: [
          'Anyone or anything that accesses data in a Solid Pod uses a unique ID, authenticated by a decentralized extension of OpenID Connect. Solid\'s access control system uses these IDs to determine whether a person or application has access to a resource in a Pod.'
        ],
        id: 'secure-sharing',
        image: 'auth-flow.png',
        videoId: '',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        learnMoreLink: '',
        html: 
          '<div><a href="https://solidproject.org/TR/oidc-primer" target="_blank" class="btn font-weight-bold btn-link btn-lg text-light" target="_self" style="text-decoration: none; padding-left: 0px !important;">' +
          'Learn More ' +
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-right fa-w-14"><path fill="currentColor" d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" class=""></path></svg></a></div>'
      },
    }
  }
};
</script>
